export type GffpParties = 'sender';

export interface GffpFieldPath {
  party: GffpParties;
  schema?: GffpSchemas;
  field: string;
}

export enum GffpFieldTypes {
  STRING = 'string',
  NUMBER = 'number',
  ARRAY = 'array',
}

// TODO -- work on date formats
export enum GffpFormats {
  FULL_YEAR = 'date-fullyear',
  DATE_MONTH = 'date-month',
  DATE_MDAY = 'date-mday',
  DATE = 'date',
  EMAIL = 'email',
}

export enum GffpSchemas {
  NAME = 'name',
  PERSONAL_DETAILS = 'personalDetails',
  ADDRESS = 'address',
  ADDRESS_INFO = 'addressInfo',
  PHONE = 'phone',
  PRIMARY_ID = 'primaryIdentification',
  SECONDARY_ID = 'secondaryIdentification',
  FAMILY_INFO = 'familyInfo',
  AMOUNT = 'amount',
  FEE_FX_RATE = 'feeAndFxRate',
  PAYOUT_OPT = 'payoutOption',
  FUNDING = 'funding',
  BUSINESS_DETAILS = 'businessDetails',
  THIRD_PARTY_BUSINESS_DETAILS = 'thirdPartyBusinessDetails',
  CUSTOM_FIELDS = 'customFields',
  ERROR_DETAILS = 'errorDetails',
  CRYPTO_INSTRUCTIONS = 'cryptoNetworkInstructions',
  CRYPTO_SETTLEMENT = 'cryptoNetworkSettlementDetails',
  FEE_QUOTE_SEND_AMOUNT = 'feeQuoteWithSendAmount',
  FEE_QUOTE_PAYOUT_AMOUNT = 'feeQuoteWithPayoutAmount',
  SEND_AMOUNT_DETAILS = 'sendAmountDetails',
  PAYOUT_AMOUNT_DETAILS = 'payoutAmountDetails',
  TRANSACTION_QUOTE_DETAILS = 'transactionQuoteDetails',
  ADDITIONAL_DETAILS = 'additionalTransactionDetails',
  QUOTE_TRANSACTION_SEND_AMOUNT = 'quoteTransactionBySendAmountRequest',
  QUOTE_TRANSACTION_PAYOUT_AMOUNT = 'quoteTransactionByPayoutAmountRequest',
  QUOTE_TRANSACTION = 'quoteTransactionResponse',
  CREATE_UPDATE_TRANSACTION_SEND_AMOUNT = 'createOrUpdateTransactionBySendAmountRequest',
  CREATE_UPDATE_TRANSACTION_PAYOUT_AMOUNT = 'createOrUpdateTransactionByPayoutAmountRequest',
  CREATE_UPDATE_TRANSACTION = 'createOrUpdateTransactionResponse',
  COMMIT_TRANSACTION_REQ = 'commitTransactionRequest',
  COMMIT_TRANSACTION_RESP = 'commitTransactionResponse',
}

export const GFFP_COUNTRY_CODES = [
  'birthCountryCode',
  'citizenshipCountryCode',
  'countryCode',
  'destinationCountryCode',
  'issueCountryCode',
];

export const GFFP_STATE_CODES = [
  'countrySubdivisionCode',
  'issueCountrySubdivisionCode',
  'destinationCountrySubdivisionCode',
];

export const GFFP_DROPDOWNS: {
  name: string;
  enum: string;
  parent?: GffpSchemas;
}[] = [
  { name: 'occupationCode', enum: 'OCCUPATION' },
  {
    name: 'typeCode',
    enum: 'PERSONAL_ID1_TYPE',
    parent: GffpSchemas.PRIMARY_ID,
  },
  {
    name: 'typeCode',
    enum: 'PERSONAL_ID2_TYPE',
    parent: GffpSchemas.SECONDARY_ID,
  },
  { name: 'purposeOfTransactionCode', enum: 'PURPSE_OF_TRNSCTION' },
  { name: 'sourceOfFundsCode', enum: 'SOURCE_OF_FUNDS' },
  { name: 'proofOfFundsCode', enum: 'PROOF_OF_FUNDS' },
  { name: 'intendedUseOfMGIServicesCode', enum: 'TYPICAL_USE_OF_MGI' },
  { name: 'relationshipToReceiver', enum: 'RLTIONSHP_TO_RECIVR' },
  { name: 'genderCode', enum: 'GENDER' },
];

export const GFFP_DEPENDENT_DROPDOWNS: { parent: string; child: string }[] = [
  {
    parent: 'countryCode',
    child: 'countrySubdivisionCode',
  },
  {
    parent: 'issueCountryCode',
    child: 'issueCountrySubdivisionCode',
  },
  {
    parent: 'destinationCountryCode',
    child: 'destinationCountrySubdivisionCode',
  },
];

export type GffpSchema = {
  [prop: string]: GffpSchemaConfig | GffpRef;
};

export interface GffpRef {
  $ref?: string;
}

export function isGffpRef(val: GffpSchemaConfig | GffpRef): val is GffpRef {
  const config: GffpRef = val as GffpRef;
  return !!config?.$ref;
}

export function isGffpSchema(
  val: GffpSchemaConfig | GffpRef
): val is GffpSchemaConfig {
  const config: GffpSchemaConfig = val as GffpSchemaConfig;

  return !!config?.properties || !!config?.type || !!config?.required;
}

export interface GffpSchemaConfig {
  required?: string[];
  properties?: { [fieldName: string]: GffpSchemaConfig | GffpRef };
  type?: string;
  minLength?: number;
  maxLength?: number;
  pattern?: string;
  description?: string;
  format?: string;
  enum?: string[];

  // TODO -- What is this?
  allOf?: (GffpRef | GffpSchemaConfig)[];
  items?: GffpRef | GffpSchemaConfig;
  minItems?: number;
}

export interface GffpFieldFormatted {
  name: string;
  label: string;
  type?: GffpFieldTypes;
  format?: GffpFormats;
  required?: boolean;
  minLength?: number;
  maxLength?: number;
  pattern?: string;
  description?: string;
  items?: GffpFieldFormatted[];

  // TODO -- not sure if used
  enum?: string[];
}

export const GFFP_FIELDS_CATEGORY = ['MAPI-40000', 'MAPI-45000'];

export interface GffpData {
  [party: string]: {
    [type: string]: {
      [field: string]: number | string;
    };
  };
}
